"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const config_1 = require("../lib/constants/config");
/**
 * Custom hook to get the height of the header element.
 * @returns {number} The height of the header element.
 */
function useHeaderHeight() {
    const [headerHeight, setHeaderHeight] = (0, react_1.useState)(0);
    (0, react_1.useLayoutEffect)(() => {
        // Ensure the hook runs only in client-side code
        if (typeof window !== 'undefined') {
            const headerElement = document.getElementById(config_1.HEADER_ELEMENT_ID);
            if (headerElement) {
                setHeaderHeight(headerElement.offsetHeight);
            }
        }
    }, []);
    return [headerHeight];
}
exports.default = useHeaderHeight;
//# sourceMappingURL=useHeaderHeight.js.map